<template>
    <div class="summary-section" :data-aos="isInternalView ? '' : 'fade-up'" data-aos-once="true">
        <v-container>
          <v-expansion-panels v-model="panel" dark accordion multiple>
            <v-expansion-panel expand>
              <v-expansion-panel-header>
                <v-app-bar
                  dark
                  color="#212121"
                  >
                  <v-toolbar-title style="text-align:center;">Lemon8 Analysis Summary</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-menu
                    :close-on-content-click="false"
                    bottom
                    left
                    v-if="showRequiredActions()"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="openColSettingsModal"
                      >
                        <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                      </v-btn>
                    </template>
                  </v-menu>
                  <v-btn
                    v-if="showRequiredActions()"
                    icon
                    color="primary"
                    @click="downloadSummary"
                  >
                    <i class="fas fa-download fa-lg" data-toggle="tooltip" data-placement="top" title="Download"></i>
                  </v-btn>
                  <v-btn
                    v-if="isInternalView && showRequiredActions()"
                    icon
                    color="primary"
                    @click.stop="$emit('open-analysis')"
                  >
                    <i class="fas fa-magic fa-lg" data-toggle="tooltip" data-placement="top" title="AI Analysis"></i>
                  </v-btn>
                  <!-- <v-menu
                    :close-on-content-click="false"
                    bottom
                    left
                    v-if="showRequiredActions()"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="secondary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item>
                        <v-checkbox
                          v-model="campaign.xhsAnalysisStatus.liveDate"
                          label="Live Date"
                          color="secondary"
                          :true-value="true"
                          :false-value="false"
                          hide-details
                          @change="updatexhsAnalysisStatus"
                        ></v-checkbox>
                      </v-list-item>
                      <v-list-item>
                        <v-checkbox
                          v-model="campaign.xhsAnalysisStatus.showShares"
                          label="Shares"
                          color="secondary"
                          :true-value="true"
                          :false-value="false"
                          hide-details
                          @change="updatexhsAnalysisStatus"
                        ></v-checkbox>
                      </v-list-item>
                      <v-list-item>
                        <v-checkbox
                          v-model="campaign.xhsAnalysisStatus.showReplies"
                          label="Replies"
                          color="secondary"
                          :true-value="true"
                          :false-value="false"
                          hide-details
                          @change="updatexhsAnalysisStatus"
                        ></v-checkbox>
                      </v-list-item>
                      <v-list-item>
                        <v-checkbox
                          v-model="campaign.xhsAnalysisStatus.showLinkClicks"
                          label="Links Click"
                          color="secondary"
                          :true-value="true"
                          :false-value="false"
                          hide-details
                          @change="updatexhsAnalysisStatus"
                        ></v-checkbox>
                      </v-list-item>
                      <v-list-item>
                        <v-checkbox
                          v-model="campaign.xhsAnalysisStatus.showStickerTaps"
                          label="Sticker Traps"
                          color="secondary"
                          :true-value="true"
                          :false-value="false"
                          hide-details
                          @change="updatexhsAnalysisStatus"
                        ></v-checkbox>
                      </v-list-item>
                      <v-list-item>
                        <v-checkbox
                          v-model="campaign.xhsAnalysisStatus.showReach"
                          label="Reach"
                          color="secondary"
                          :true-value="true"
                          :false-value="false"
                          hide-details
                          @change="updatexhsAnalysisStatus"
                        ></v-checkbox>
                      </v-list-item>
                      <v-list-item>
                        <v-checkbox
                          v-model="campaign.xhsAnalysisStatus.showImpressions"
                          label="Impressions"
                          color="secondary"
                          :true-value="true"
                          :false-value="false"
                          hide-details
                          @change="updatexhsAnalysisStatus"
                        ></v-checkbox>
                      </v-list-item>
                      <v-list-item>
                        <v-checkbox
                          v-model="campaign.xhsAnalysisStatus.showAvgViews"
                          label="Average Views"
                          color="secondary"
                          :true-value="true"
                          :false-value="false"
                          hide-details
                          @change="updatexhsAnalysisStatus"
                        ></v-checkbox>
                      </v-list-item>
                      <v-list-item>
                        <v-checkbox
                          v-model="campaign.xhsAnalysisStatus.showAvgReelsPlays"
                          label="Average Reels Plays"
                          color="secondary"
                          :true-value="true"
                          :false-value="false"
                          hide-details
                          @change="updatexhsAnalysisStatus"
                        ></v-checkbox>
                      </v-list-item>
                    </v-list>
                  </v-menu>                                         -->
                </v-app-bar>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card
                id="lemon-analysis-summary"
                class="mx-auto"
                outlined
                color="#000000"
                >
                  <v-card-text>
                      <div>
                        <!-- Group Filter Buttons (right aligned, no "All" button) -->
                  <div v-if="groups.length > 0" class="group-filter-btns-right">
                    <div class="group-btns">
                      <v-btn
                        v-for="group in groups"
                        :key="group.groupID"
                        :color="selectedGroup === group.groupID ? 'orange' : '#fff'"
                        :class="['group-btn', { 'active-btn': selectedGroup === group.groupID }]"
                        @click="selectedGroup = selectedGroup === group.groupID ? null : group.groupID"
                        depressed
                        small
                        style="margin-right:8px; color: #212121;"
                      >
                        {{ group.groupName || group.groupID }}
                      </v-btn>
                    </div>
                    </div>
                    <div class="text-right mb-2">
                      <!-- Save and Cancel buttons for drag-and-drop reordering -->
                      <v-btn
                        @click.native.stop
                        @click="cancelPostOrder"
                        color="warning"
                        dark
                        v-if="editPostOrder"
                        class="mr-2"
                        small
                      >
                        Cancel
                      </v-btn>

                      <v-btn
                        @click.native.stop
                        @click="savePostOrder"
                        color="success"
                        dark
                        v-if="editPostOrder"
                        class="mr-2"
                        small
                      >
                        <v-icon small>mdi-content-save</v-icon> Save Changes
                      </v-btn>
                    </div>
                        <v-data-table
                            dark
                            :headers="computedHeaders"
                            :items="filteredItems"
                            item-key="key"
                            :items-per-page="-1"
                            class="elevation-15"
                            :key="dataTableKey"
                            v-sortable-data-table
                            @sorted="handleDataTableDragDrop"
                            :custom-sort="customSort"
                          >
                          <template v-for="(h, index) in computedHeaders" v-slot:[`header.${h.value}`]="{ header }">
                            <legend-icon :key="index" :header="h" />
                          </template>
                          <template v-slot:item.name="{ item }">
                            <div class="d-flex align-center">
                              <v-icon
                                small
                                class="move-cursor"
                              >
                                mdi-arrow-all
                              </v-icon>
                              <v-btn
                                v-if="isInternalView"
                                class="btn-reload"
                                text
                                x-small
                                color="warning"
                                @click="refreshReportInf(item.id)"
                              >
                                <v-icon dark small>
                                  mdi-reload
                                </v-icon>
                              </v-btn>
                              <a class="caption" style="color:#fff" :href="'https://lemon8-app.com/' + item.name" target="_blank">@{{item.name}}</a>
                            </div>
                          </template>
                          <template v-slot:item.outreach="{ item }">
                            {{item.outreach === 0 || !item.outreach ? '-' : item.outreach | thousandSeprator}}
                          </template>
                          <template v-slot:item.views="{ item }">
                            {{item.views === 0 ? '-' : item.views | thousandSeprator}}
                          </template>
                          <template v-slot:item.watches="{ item }">
                            {{item.watches === 0 ? '-' : item.watches}}
                          </template>
                          <template v-slot:item.like_count="{ item }">
                            {{item.like_count === 0 ? '-' : item.like_count | thousandSeprator}}
                          </template>
                          <template v-slot:item.comment_count="{ item }">
                            {{item.comment_count === 0 ? '-' : item.comment_count | thousandSeprator}}
                          </template>
                          <template v-slot:item.shares="{ item }">
                            {{item.shares === 0 ? '-' : item.shares | thousandSeprator}}
                          </template>
                          <template v-slot:item.bookmarks="{ item }">
                            {{item.bookmarks === 0 ? '-' : item.bookmarks | thousandSeprator}}
                          </template>
                          <template slot="body.append">
                              <tr style="font-weight:500;">
                                  <td><strong>TOTAL</strong></td>
                                  <template v-for="header in computedHeaders">
                                    <td :key="header.value" v-if="header.value !== 'name'">
                                      <strong>
                                        <template v-if="header.value === 'live_date'">-</template>
                                        <template v-else-if="header.value === 'outreach'">{{ totalOutreach === 0 ? '-' : totalOutreach | thousandSeprator }}</template>
                                        <template v-else-if="header.value === 'views'">{{ totalViews === 0 ? '-' : totalViews | thousandSeprator }}</template>
                                        <template v-else-if="header.value === 'watches'">{{ totalWatches == 0 ? '-' : totalWatches | thousandSeprator }}</template>
                                        <template v-else-if="header.value === 'like_count'">{{ totalLikes === 0 ? '-' : totalLikes | thousandSeprator }}</template>
                                        <template v-else-if="header.value === 'bookmarks'">{{ totalBookmarks === 0 ? '-' : totalBookmarks | thousandSeprator }}</template>
                                        <template v-else-if="header.value === 'comment_count'">{{ totalComments === 0 ? '-' : totalComments | thousandSeprator }}</template>
                                        <template v-else-if="header.value === 'shares'">{{ totalShares === 0 ? '-' : totalShares | thousandSeprator }}</template>
                                        <template v-else-if="header.value === 'interactions'">{{ totalInteractions === 0 ? '-' : totalInteractions | thousandSeprator }}</template>
                                      </strong>
                                    </td>
                                  </template>
                              </tr>
                          </template>
                          </v-data-table>
                      </div>
                      <!-- <legend-section
                        :showleftSideIcon="true"
                        :rightSections="storyLegends"
                      ></legend-section> -->
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
        <table-cols-show-hide-modal
          v-model="colSettingsDialog"
          title="Lemon8 Analysis Summary"
          :items="tableColsItems"
          @updated="updatelemonAnalysisStatus"
          :isSort="true"
        />
    </div>
</template>
<style lang="css">
    .theme--dark.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
        border: thin solid rgba(255, 255, 255, 0.12) !important;
    }
    .theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
      cursor: move;
    }
    .move-cursor {
      cursor: move;
      float: left;
    }
</style>

<style scoped>
.group-filter-btns-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 16px;
}
.group-btns {
  display: flex;
  align-items: center;
}
.group-btn {
  min-width: 48px;
  font-weight: 500;
  background: #fff !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  color: #212121 !important;
  transition: background 0.2s, color 0.2s;
}
.active-btn {
  background: orange !important;
  color: #fff !important;
}
</style>
<script>
/* eslint-disable */
import html2canvas from 'html2canvas';
import LegendSection from './Legend'
import LegendIcon from './LegendIcon'
// import campaignAPIs from '../views/Campaign/campaignAPIs'
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import campaignHelper from '../views/Campaign/campaignHelper';
import config from '@/config'
import campaignAPIs from '../views/Campaign/campaignAPIs';
export default {
  name: 'rpt_story_summary',
  props: ['posts', 'campaign', 'defaultCols', 'isInternalView'],
  components: {
    LegendSection,
    LegendIcon,
    TableColsShowHideModal
  },
  data () {
    return {
      page: 1,
      sortBy: 'live_date',
      sortDesc: true,
      dataTableKey: 0,
      disableSaveArrange: true,
      lineUpItems: [],
      panel: [0, 1],
      storyLegends: [],
      colSettingsDialog: false,
      selectedGroup: null,
      tableColsItems: [],
      editPostOrder: false,
      originalPosts: [],
      headers: [
        {
          text: 'Influencer',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Live Date',
          value: 'live_date',
          legendText: 'Live Date'
        },
        {
          text: 'Audience Size',
          value: 'outreach',
          legendText: 'The number of followers the creator has at the time where the post was made '
        },
        {
          text: 'Views',
          value: 'views',
          legendText: 'The number of views.'
        },
        {
          text: 'Average Watch Time',
          value: 'watches',
          legendText: 'How many seconds your video is viewed for'
        },
        {
          text: 'Likes',
          value: 'like_count',
          legendText: `The total number of likes`
        },
        {
          text: 'Saves',
          value: 'bookmarks',
          legendText: 'The number of saves.'
        },
        {
          text: 'Comments',
          value: 'comment_count',
          legendText: 'The number of comments.'
        },
        {
          text: 'Shares',
          value: 'shares',
          legendText: 'The number of times users have reposted / shared a story.'
        },
        {
          text: 'Interactions',
          value: 'interactions',
          legendText: 'The sum of likes, comments, saves, shares'
        }
      ],
      showHideFields: [
        { name: 'liveDate', label: 'Live Date' },
        { name: 'showViews', label: 'Views' },
        { name: 'showWatches', label: 'Average Watch Time' },
        { name: 'showLikes', label: 'Likes' },
        { name: 'showBookmarks', label: 'Saves' },
        { name: 'showComments', label: 'Comments' },
        { name: 'showShares', label: 'Shares' },
        { name: 'showInteractions', label: 'Interactions' }
      ],
      // storyLeftSection: [
      //   {
      //     title: 'Likes',
      //     description: 'Number of likes'
      //   },
      //   {
      //     title: 'Comments',
      //     description: 'Number of comments'
      //   },
      //   {
      //     title: 'Shares',
      //     description: 'Number of shares'
      //   },
      //   {
      //     title: 'Saves',
      //     description: 'Number of unique account that saved your post'
      //   },
      //   {
      //     title: 'Impressions',
      //     description: 'Total number of times content have been shown to users'
      //   },
      //   {
      //     title: 'Reach',
      //     description: 'Number of unique user that seen your content'
      //   },
      //   {
      //     title: 'Views',
      //     description: 'How many users watched your video more than three seconds'
      //   }
      // ],
      storyRightSection: [
        {
          title: 'Live Date',
          description: 'Live Date'
        },
        {
          title: 'Audience Size',
          description: 'Audience size (followers at post time)'
        },
        {
          title: 'Shares',
          description: 'Number of times story was shared'
        },
        {
          title: 'Replies',
          description: 'Number of replies to photo or video in your stories'
        },
        {
          title: 'Links Click',
          description: 'Number of people who swipe up on a story to follow a link'
        },
        {
          title: 'Sticker Taps',
          description: 'Number of times users interacted with the stickers/handle'
        },
        {
          title: 'Reach',
          description: 'Number of unique user that seen your content'
        },
        {
          title: 'Impressions',
          description: 'Total number of times content have been shown to users'
        },
        {
          title: 'Average Views',
          description: 'Average views over the last 30 posts'
        },
        {
          title: 'Average Reels Plays',
          description: 'Average plays over the last 30 posts'
        }
        // {
        //   title: 'Profile Visits',
        //   description: 'Number of times users clicked through your profile through stories'
        // }
      ]
    }
  },
  computed: {
    sortedPosts() {
      return this.posts
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    groups() {
      const groupMap = new Map();
      this.sortedPosts.forEach(post => {
        if (post.groupID && post.groupName) {
          groupMap.set(post.groupID, post.groupName);
        }
        if (Array.isArray(post.reports)) {
          post.reports.forEach(report => {
            if (report.groupID && report.groupName) {
              groupMap.set(report.groupID, report.groupName);
            }
          });
        }
      });
      return Array.from(groupMap, ([groupID, groupName]) => ({
        groupID,
        groupName
      }));
    },
    filteredItems() {
      if (!this.selectedGroup) return this.sortedPosts;
      return this.sortedPosts.filter(post => {
        if (post.groupID === this.selectedGroup) return true;
        if (Array.isArray(post.reports)) {
          return post.reports.some(report => report.groupID === this.selectedGroup);
        }
        return false;
      });
    },
    computedHeaders() {
      const status = this.campaign.lemonAnalysisStatus || {};
      const finalHeaders = [];

      // 1. Add the "Influencer" column first (always fixed)
      const nameHeader = this.headers.find(h => h.value === 'name');
      if (nameHeader) {
        finalHeaders.push(nameHeader);
      }

      // 2. Iterate through the keys of lemonAnalysisStatus to determine order and visibility
      for (const statusKey in status) {
        if (Object.prototype.hasOwnProperty.call(status, statusKey)) {
          const isVisible = status[statusKey];
          if (isVisible) {
            // Find the corresponding header from `headers` using `showHideFields` as a map
            const field = this.showHideFields.find(f => f.name === statusKey);
            if (field) {
              const header = this.headers.find(h => h.text === field.label);
              if (header) {
                finalHeaders.push(header);
              }
            } else {
              // Fallback for keys that might directly match header values
              const header = this.headers.find(h => h.value === statusKey);
              if (header) {
                finalHeaders.push(header);
              }
            }
          }
        }
      }
      return finalHeaders;
    },
    totalOutreach() {
      let outreach = 0;
      this.filteredItems.map(item => {
        outreach += item.outreach ? Number(item.outreach) : 0
      })
      return outreach
    },
    totalLikes() {
      let likeCount = 0;
      this.filteredItems.map(item => {
        likeCount += item.like_count ? Number(item.like_count) : 0
      })
      return likeCount
    },
    totalComments() {
      let commentCount = 0;
      this.filteredItems.map(item => {
        commentCount += item.comment_count ? Number(item.comment_count) : 0
      })
      return commentCount
    },
    totalViews() {
      let views = 0;
      this.filteredItems.map(item => {
        views += item.views ? Number(item.views) : 0
      })
      return views
    },
    totalWatches() {
      let watches = 0;
      this.filteredItems.map(item => {
        watches += item.watches ? Number(item.watches) : 0
      })
      return watches
    },
    totalShares() {
      let shares = 0;
      this.filteredItems.map(item => {
        shares += item.shares ? Number(item.shares) : 0
      })
      return shares
    },
    totalBookmarks() {
      let bookmarks = 0;
      this.filteredItems.map(item => {
        bookmarks += item.bookmarks ? Number(item.bookmarks) : 0
      })
      return bookmarks
    },
    totalInteractions() {
      let interactions = 0;
      this.filteredItems.map(item => {
        interactions += item.interactions ? Number(item.interactions) : 0
      })
      return interactions
    }
  },
  mounted() {
    this.updateLegend();
  },
  methods: {
    customSort: function(items, index, isDesc) {
      items.sort((a, b) => {
        if (!(isNaN(a[index[0]]))) {
          if (!isDesc[0]) {
            return (a[index[0]] - b[index[0]]);
          } else {
            return (b[index[0]] - a[index[0]]);
          }
        } else {
          if (!isDesc[0]) {
            return (a[index[0]] < b[index[0]]) ? -1 : 1;
          } else {
            return (b[index[0]] < a[index[0]]) ? -1 : 1;
          }
        }
      })
      this.lineUpItems = Object.assign([], items)
      this.disableSaveArrange = false
      return items;
    },
    handleDataTableDragDrop(event, items) {
      // check and save drag n drop update for table items/ grouped items
      if (items.length === 0 || !this.showRequiredActions()) {
        return;
      }
      
      if (!this.editPostOrder) {
        this.originalPosts = JSON.parse(JSON.stringify(this.posts));
      }
      
      const itemsPerPage = 15;
      const oldIndex = ((this.page - 1) * itemsPerPage) + event.oldIndex;
      const newIndex = ((this.page - 1) * itemsPerPage) + event.newIndex;
      let tmpPosts = []
      let groupID = items[0].groupID
      if (groupID) {
        let group = this.sortedPosts.find(p => p.id === groupID)
        if (group) {
          tmpPosts = group.reports
        }
      } else {
        tmpPosts = Object.assign([], this.sortedPosts)
      }
      const movedItem = tmpPosts.splice(oldIndex, 1)[0]
      tmpPosts.splice(newIndex, 0, movedItem)
      if (groupID) {
        this.posts = this.sortedPosts.map(p => {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(tmp => tmp)
          }
          return p
        })
      } else {
        this.posts = tmpPosts.map(tmp => tmp)
      }
      this.lineUpItems = []
      this.lineUpItems = Object.assign([], tmpPosts)
      this.disableSaveArrange = false
      this.editPostOrder = true
    },
    savePostOrder() {
      this.updateLineUp();
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    cancelPostOrder() {
      this.posts = JSON.parse(JSON.stringify(this.originalPosts));
      this.lineUpItems = [];
      this.disableSaveArrange = true;
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    async updateLineUp() {
      await this.lineUpItems.map((item, index) => {
        let data = {}
        if (item.reportGroup) {
          data.groupID = item.id
          data.lineUpIndex = index
          data.posts = item.reports.map((element, rindex) => {
            return Object.assign({}, { id: element.id, lineUpIndex: rindex })
          })
        } else {
          data = {
            reportID: item.id,
            campaignID: item.campaignID,
            lineUpIndex: index
          }
        }
        campaignAPIs.updateLineUpIndex(data)
      })
    },
    updateLegend() {
      let filteredLegend = this.storyRightSection.filter(s => {
        let lemonAnalysisStatus = this.campaign.lemonAnalysisStatus
        if (!lemonAnalysisStatus.showShares && s.title === 'Shares') {
          return false
        }
        if (!lemonAnalysisStatus.showReplies && s.title === 'Replies') {
          return false
        }
        if (!lemonAnalysisStatus.showLinkClicks && s.title === 'Links Click') {
          return false
        }
        if (!lemonAnalysisStatus.showStickerTaps && s.title === 'Sticker Taps') {
          return false
        }
        if (!lemonAnalysisStatus.showReach && s.title === 'Reach') {
          return false
        }
        if (!lemonAnalysisStatus.showImpressions && s.title === 'Impressions') {
          return false
        }
        if (!lemonAnalysisStatus.liveDate && s.title === 'Live Date') {
          return false
        }
        if (!lemonAnalysisStatus.showAvgViews && s.title === 'Average Views') {
          return false
        }
        if (!lemonAnalysisStatus.showAvgReelsPlays && s.title === 'Average Reels Plays') {
          return false
        }
        return true
      });
      this.storyLegends = filteredLegend
    },
    async updatelemonAnalysisStatus(items) {
      await this.updateColumnsStatus(items, 'lemonAnalysisStatus', 'colSettingsDialog');
    },
    showRequiredActions: function() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false
      } else {
        return config.userRoles.CLIENT !== this.currentUserRole
      }
    },
    openColSettingsModal() {
      this.initializeLemonAnalysisTableCols();
      this.colSettingsDialog = true
    },
    initializeLemonAnalysisTableCols() {
        this.tableColsItems = campaignHelper.getOrderedColumns(
          this.showHideFields,
          this.campaign.lemonAnalysisStatus,
          this.defaultCols
        );
    },
    async updateColumnsStatus(items, campaignDataProp, dialogProp) {
        let newStatusObject = {};
        items.forEach((item) => {
            newStatusObject[item.key] = item.value;
        });
        let data = [
            Object.assign({}, {
                id: this.campaign.id,
                [campaignDataProp]: newStatusObject
            })
        ];
        try {
            await this.$store.dispatch('campaign/updateCampaignByIds', data);
            this.campaign[campaignDataProp] = newStatusObject;
            this[dialogProp] = false;
        } catch (error) {
            console.error('Error updating campaign settings:', error);
        }
    },
    downloadSummary() {
      const element = document.getElementById('lemon-analysis-summary');
      html2canvas(element).then(canvas => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'lemon-analysis-summary.png';
        link.click();
      });
    },
    refreshReportInf(id) {
      this.$emit('refreshReportInf', id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// LemonSummary.vue?778e8f0a